import React, { useEffect, useRef, useState, useCallback, useMemo } from 'react'
import { getApi, postApi, putApi } from '../../../Services/apiService';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { fetchBrandFilter, fetchCategoryDataFilter, fetchOriginDataFilter, fetchPicImportDataFilter, fetchPicSalesDataFilter, filteredCategories, handleImportClickFile, handleSelectionChange, relatedProductsLoadOptions, TableFooter, transformData } from '../../../Utils/helper';
import { format, addDays, eachDayOfInterval, getDay } from 'date-fns';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import MultiSelectDropdown from '../../../Utils/multiSelectDropdown';
import Import from '../../../Utils/import';
import GenerateTable from './generateTable';
import { exportData } from './exportData';
import { useDispatch } from 'react-redux';
import { fetchPermissionData } from "../../../Counter/permissionData";

// Memoized components
const MemoizedMultiSelectDropdown = React.memo(MultiSelectDropdown);
const MemoizedGenerateTable = React.memo(GenerateTable);

function Inout() {
  const dispatch = useDispatch()
  const tableRef = useRef(null);
  const navigate = useNavigate()
  const { RangePicker } = DatePicker;
  const dropdownRef = useRef(null);
  const modalRef = useRef(null)
  const [categoryOpen, setCategoryOpen] = useState(false)
  const [categoryData, setCategoryData] = useState([])
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([])
  const [selectedOriginIds, setSelectedOriginIds] = useState([])
  const [originOpen, setOriginOpen] = useState(false)
  const [originData, setOriginData] = useState([])
  const [picImporttOpen, setPicImporttOpen] = useState(false)
  const [picSalesOpen, setPicSalesOpen] = useState(false)
  const [picSalesData, setPicSalesData] = useState([])
  const [picImportData, setPicImportData] = useState([])
  const [productData, setProductData] = useState([])
  const [totalProduct, setTotalProduct] = useState(0)
  const [selectedPicImport, setSelectedPicImport] = useState([])
  const [selectedPicSales, setSelectedPicSales] = useState([])
  const [brandOpen, setBrandOpen] = useState(false)
  const [brandData, setBrandData] = useState([])
  const [selectedBrandName, setSelectedBrandName] = useState([])
  const [dateState, setDateState] = useState({
    startDate: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
    endDate: dayjs().add(1, 'month').format('YYYY-MM-DD')
  });
  const [searchTerm, setSearchTerm] = useState('');
  const [filterDatas, setFilterData] = useState([])
  const [inoutData, setInoutData] = useState({})
  const [arrivalModalShow, setArrivalModalShow] = useState(false)
  const [arrivalModalData, setArrivalModalData] = useState({})
  const [productIds, setProductIds] = useState([])
  const [selectedProductsData, setSelectedProductsData] = useState([])
  const [perPageSearch, setPerPageSearch] = useState(1);
  const [reserveUpdateData, setReserveUpdateData] = useState([])
  const [inputValues, setInputValues] = useState({})
  const [modalReserve, setModalReserve] = useState(false)
  const [reserveModalUpdateData, setReserveModalUpdateData] = useState([])
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [quantityValue, setQuantityValue] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  const [searchInputValue, setSearchInputValue] = useState('');
  const [isEditing, setIsEditing] = useState('');
  const [updateValue, setUpdateValue] = useState(null);
  const [updateId, setUpdateId] = useState(null);
  const [updateDate, setUpdateDate] = useState(null);
  const [updateProduct, setUpdateProduct] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemPerPage] = useState(150);
  const [allDatess, setAllDates] = useState([]);
  const [reserveModalError, setReserveModalError] = useState('');
  const [totalPage, setTotalPages] = useState(0);
  const [tableLoader, setTableLoader] = useState(false);
  const [showGroupData, setshowGroupData] = useState(null);
  const [selectedGroupProducts, setSelectedGroupProducts] = useState([]);
  const [toastMessage, setToastMessage] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [importErrors, setImportErrors] = useState({
    file: '',
    general: ''
  });
  const [showAllArrivals, setShowAllArrivals] = useState(false);
  // Add state for arrival modal selection and quantity
  const [selectedArrivalProductId, setSelectedArrivalProductId] = useState(null);
  const [selectedArrivalProductData, setSelectedArrivalProductData] = useState({});
  const [arrivalQuantityMap, setArrivalQuantityMap] = useState({});
  const [arrivalModalError, setArrivalModalError] = useState('');
  const [arrivalModalLoading, setArrivalModalLoading] = useState(false);
  const [productSearchInput, setProductSearchInput] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const [productLabelModal, setProductLabelModal] = useState(false);
  const [labelData, setLabelData] = useState([]);
  const [subGroup, setSubGroup] = useState('');
  const [groupName, setGroupName] = useState('');
  const [productName, setProductName] = useState('');
  const [labelDate, setLabelDate] = useState(null);
  const productSearchRef = useRef(null);
  const [loader, setLoader] = useState(false);
  const [productGroupLabelModal, setProductGroupLabelModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const [selectAll, setSelectAll] = useState(false);
  const [productLoader, setProductLoader] = useState(false);
  const handleScroll = (e) => {
    setScrolled(e.target.scrollTop > 0);
  };
  const groupRef = useRef(null);
  const firstRadioRefProductLabel = useRef(null);
  const firstRadioArrivalRef = useRef(null);
  const quatityRef = useRef(null);

  useEffect(() => {
  if (productGroupLabelModal && groupRef.current) {
    groupRef.current.focus();
  }
  if (productLabelModal && firstRadioRefProductLabel.current) {
    firstRadioRefProductLabel.current.focus();
  }
  if (arrivalModalShow && firstRadioArrivalRef.current) {
    firstRadioArrivalRef.current.focus();
  }
}, [productGroupLabelModal,productLabelModal,arrivalModalShow]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      // ESC key closes any open modal
      if (event.key === 'Escape' && (modalReserve || arrivalModalShow || productGroupLabelModal || productLabelModal)) {
        handleCloseModal();
      }
      // Enter key submits the form in modals
      if ((event.key === 'Enter' || event.key === 'return') && modalReserve) {
        event.preventDefault();
        document.getElementById('modal-save-btn')?.click();
      }

      if (event.key === 'Enter' && arrivalModalShow) {
        event.preventDefault();
        document.getElementById('arrival_modal')?.click();
      }
      if (event.key === 'Enter' && productGroupLabelModal) {
        event.preventDefault();
        document.getElementById('modal-save-btng')?.click();
      }
      if (event.key === 'Enter' && productLabelModal) {
        event.preventDefault();
        document.getElementById('modal-save-btnp')?.click();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [modalReserve, arrivalModalShow,productGroupLabelModal,productLabelModal]);

  useEffect(() => {
    dispatch(fetchPermissionData()); // Fetch data only if not already available
  }, []);

  useEffect(() => {
    if (modalReserve || arrivalModalShow) {
      // Focus the first focusable element when modal opens
      const modal = modalRef.current;
      if (modal) {
        const focusableElements = modal.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (focusableElements.length > 0) {
          focusableElements[0].focus();
        }

        // Trap focus within modal
        const handleTabKey = (e) => {
          if (e.key === 'Tab') {
            const focusableElements = modal.querySelectorAll(
              'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );
            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];

            if (!e.shiftKey && document.activeElement === lastElement) {
              firstElement.focus();
              e.preventDefault();
            }

            if (e.shiftKey && document.activeElement === firstElement) {
              lastElement.focus();
              e.preventDefault();
            }
          }
        };

        modal.addEventListener('keydown', handleTabKey);
        return () => modal.removeEventListener('keydown', handleTabKey);
      }
    }
  }, [modalReserve, arrivalModalShow]);

  const handleCloseModal = () => {
    setProductGroupLabelModal(false)
    setArrivalModalShow(false)
    setModalReserve(false);
    setReserveModalUpdateData([]);
    setReserveModalError('');
    setIsEditing('');
    setUpdateValue(null);
    setUpdateId(null);
    setUpdateDate(null);
    setUpdateProduct(null);
    setProductLabelModal(false)
  };

  // Memoize expensive computations
  const memoizedDateRange = useMemo(() => {
    const startDate = new Date(dateState?.startDate);
    const toDate = new Date(dateState?.endDate);
    return eachDayOfInterval({ start: startDate, end: toDate });
  }, [dateState.startDate, dateState.endDate]);

  // Memoize filtered data
  const memoizedFilteredData = useMemo(() => {
    if (searchTerm === '') return [];

    if (categoryOpen) return filteredCategories(searchTerm, categoryData);
    if (originOpen) return filteredCategories(searchTerm, originData);
    if (brandOpen) return filteredCategories(searchTerm, brandData);
    if (picImporttOpen) return filteredCategories(searchTerm, picImportData);
    if (picSalesOpen) return filteredCategories(searchTerm, picSalesData);

    return [];
  }, [searchTerm, categoryOpen, originOpen, brandOpen, picImporttOpen, picSalesOpen,
    categoryData, originData, brandData, picImportData, picSalesData]);

  // Optimize API calls with useCallback
  const fetchBrandData = useCallback(async () => {
    try {
      const resp = await getApi(`/brand`);
      if (resp?.success) {
        setBrandData(resp?.data?.brands);
      }
    } catch (error) {
      console.error('Error fetching brand data:', error);
    }
  }, []);

  const fetchCategoryData = useCallback(async () => {
    try {
      const resp = await getApi(`/product-category?per_page=9999`);
      if (resp?.success === true) {
        setCategoryData(resp?.data?.productCategories?.data || []);
      }
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  }, []);

  const fetchOriginData = useCallback(async () => {
    try {
      const resp = await getApi(`/product-origin?per_page=9999`);
      if (resp?.success === true) {
        setOriginData(resp?.data?.productOrigins?.data || []);
      }
    } catch (error) {
      console.error('Error fetching origin data:', error);
    }
  }, []);

  const fetchPicImportData = useCallback(async () => {
    try {
      const resp = await getApi(`/product_pic_staff_member?type=import`);
      if (resp?.success === true) {
        setPicImportData(resp?.data?.data || []);
      }
    } catch (error) {
      console.error('Error fetching PIC import data:', error);
    }
  }, []);

  const fetchPicSalesData = useCallback(async () => {
    try {
      const resp = await getApi(`/product_pic_staff_member?type=sales`);
      if (resp?.success === true) {
        setPicSalesData(resp?.data?.data || []);
      }
    } catch (error) {
      console.error('Error fetching PIC sales data:', error);
    }
  }, []);

  const getInOutData = async () => {
    // setTableLoader(true)
    setLoader(true)
    try {
      const startDate = new Date(dateState?.startDate);
      const toDate = new Date(dateState?.endDate);
      const allDate = eachDayOfInterval({ start: startDate, end: toDate })
      setAllDates(allDate);
      const calculatedTotalPages = Math.ceil(allDate.length / itemsPerPage);
      setTotalPages(calculatedTotalPages);
      const startIdx = (currentPage - 1) * itemsPerPage;
      const endIdx = startIdx + itemsPerPage;
      const currentDates = allDate.slice(startIdx, endIdx);
      const fromDate = format((currentDates[0]), 'yyyy-MM-dd');
      // const fromDate = format(addDays(currentDates[0], 1), 'yyyy-MM-dd');
      const endDate = format(addDays(currentDates[currentDates.length - 1], 1), 'yyyy-MM-dd');
      const queryParams = new FormData();
      // const queryParams = new URLSearchParams();
      // if(!selectAll){
        if (Array.isArray(productIds)) {
          productIds.forEach((id) => queryParams.append('product_ids[]', id));
        } else if (productIds) {
          queryParams.append('product_ids[]', productIds);
        }
      // }

    if(selectAll){
      // if (Array.isArray(selectedCategoryIds)) {
      //   selectedCategoryIds.forEach((id) => queryParams.append('category_ids[]', id));
      // } else if (selectedCategoryIds) {
      //   queryParams.append('category_ids[]', selectedCategoryIds);
      // }
      // 
      // if (Array.isArray(selectedOriginIds)) {
      //   selectedOriginIds.forEach((id) => queryParams.append('origin_ids[]', id));
      // } else if (selectedOriginIds) {
      //   queryParams.append('origin_ids[]', selectedOriginIds);
      // }
      // 
      // if (Array.isArray(selectedBrandName)) {
      //   selectedBrandName.forEach((id) => queryParams.append('brands[]', id));
      // } else if (selectedBrandName) {
      //   queryParams.append('brands[]', selectedBrandName);
      // }
      // 
      // if (Array.isArray(selectedPicImport)) {
      //   selectedPicImport.forEach((id) => queryParams.append('pic_staff_member_import[]', id));
      // } else if (selectedPicImport) {
      //   queryParams.append('pic_staff_member_import[]', selectedPicImport);
      // }
      // 
      // if (Array.isArray(selectedPicSales)) {
      //   selectedPicSales.forEach((id) => queryParams.append('pic_staff_member_sales[]', id));
      // } else if (selectedPicSales) {
      //   queryParams.append('pic_staff_member_sales[]', selectedPicSales);
      // }
    }
      queryParams.append('from_date', fromDate);
      queryParams.append('to_date', endDate);
      // if (searchValue !== '') {
      // {(searchValue!=='' && selectedCategoryIds?.length==0 && selectedOriginIds?.length==0 && productIds?.length=== productData?.length) &&
      //   queryParams.append('search', searchValue);
      // }
      const resp = await postApi(`/direct_in_out`,queryParams);
      if (resp?.success === true) {
        setInoutData(resp?.data)
        // setTableLoader(false)
        setLoader(false)
      }
    } catch (error) {
      console.error('Error in processing:', error);
    } finally {
      // setTableLoader(false)
      setLoader(false)
    }
  }
  const debouncedUpdateReserveData = async (data, value, keyId) => {
    const val = String(Number(value))
    // Clear previous timeout if still waiting
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    // Update state immediately (not debounced)
    if (data?.id) {
      setInputValues(prev => ({
        ...prev,
        [keyId]: val
      }));

      setReserveUpdateData(prevData => {
        const existingIndex = prevData.findIndex(item => item.id === data.id);
        if (existingIndex >= 0) {
          const newData = [...prevData];
          newData[existingIndex] = { id: data.id, quantity: val };
          return newData;
        }
        return [...prevData, { id: data.id, quantity: val }];
      });
    }

    // Set a new timeout for the API calls
    debounceTimer.current = setTimeout(async () => {
      try {
        setLoader(true) // Changed from setToastMessage(true)
        if (data?.id) {
          const urlEncodedData = new URLSearchParams();
          urlEncodedData.append('quantity', val || 0);
          const resp = await putApi(`/reserve/${data?.id}`, urlEncodedData.toString());

          if (resp?.success === true) {
            setReserveUpdateData([]);
            setInputValues({});
            setModalReserve(false);
            setProductLabelModal(false)
            setReserveModalUpdateData([]);
            setSelectedProductId(null);
            setQuantityValue(0);
            fetchData();
            setProductGroupLabelModal(false)
          }
          else{
            setLoader(false)
          }
        } else {
          const urlEncodedData = new URLSearchParams();
          urlEncodedData.append('start_date', data?.date);
          urlEncodedData.append('end_date', data?.date);
          urlEncodedData.append('customer_group_id', data?.customer_group_name);
          urlEncodedData.append('customer_sub_group_id', data?.customer_sub_group_name);
          urlEncodedData.append(`dates[0][date]`, data?.date);
          urlEncodedData.append(`dates[0][quantity]`, val || '0');

          if (data?.type === 'productGroup') {
            const resp = await getApi(`/product-group/${data?.product_group_name}`);
            if (resp?.success === true) {
              const mainProduct = resp?.data?.productGroup?.products.find(product => product.is_main_product === 1);
              if (mainProduct) {
                urlEncodedData.append('product_id', mainProduct.id);
                const response = await postApi('/reserve', urlEncodedData.toString());
                if (response?.success === true) {
                  fetchData();
                }
              } else {
                toast.error('No main product found');
              }
            }
          } else {
            urlEncodedData.append('product_id', data?.product_name);
            const response = await postApi('/reserve', urlEncodedData.toString());
            if (response?.success === true) {
              fetchData();
            }else{
              setLoader(false)
            }
          }
        }
        // setLoader(false) // Changed from setToastMessage(false)
        setIsEditing('');
        setUpdateValue(null);
        setUpdateId(null);
        setUpdateDate(null);
        setUpdateProduct(null);
        setLabelDate(null);
        setLabelData([]);
        setSubGroup('');
        setGroupName('');
        setProductName('');
        setProductLabelModal(false);
        setSelectedProductId(null);
        setProductGroupLabelModal(false)
      } catch (error) {
        setLoader(false)
        setIsEditing('');
        setUpdateValue(null);
        setUpdateId(null);
        setUpdateDate(null);
        setUpdateProduct(null);
        setLabelDate(null);
        setLabelData([]);
        setSubGroup('');
        setGroupName('');
        setProductName('');
        setProductLabelModal(false);
        setSelectedProductId(null);
        setProductGroupLabelModal(false)
        console.error('Error in debounced API call:', error);
      }
    }, 500);
  };
 
  useEffect(() => {
    const fetchInitialData = async () => {
      await Promise.all([
        fetchBrandData(),
        fetchCategoryData(),
        fetchOriginData(),
        fetchPicImportData(),
        fetchPicSalesData()
      ]);
    };

    fetchInitialData();
    setArrivalModalShow(false);
    setModalReserve(false);
  }, [fetchBrandData, fetchCategoryData, fetchOriginData, fetchPicImportData, fetchPicSalesData]);

  

  useEffect(() => {
    let isCancelled = false;
  
    const trimmedSearch = searchValue.trim();
    const hasCategory = selectedCategoryIds?.length > 0;
    const hasOrigin = selectedOriginIds?.length > 0;
    const hasBrand = selectedBrandName?.length > 0;
    const hasSales = selectedPicSales?.length > 0;
    const hasImport = selectedPicImport?.length > 0;
    const hasSearch = trimmedSearch !== '';
  
    const runFetch = async () => {
      if (hasCategory || hasOrigin || hasSearch || hasBrand || hasSales || hasImport) {
        setProductLoader(true)
        try {
          const queryParams = new URLSearchParams();
          if (Array.isArray(selectedCategoryIds)) {
            selectedCategoryIds.forEach((id) => queryParams.append('category_ids[]', id));
          } else if (selectedCategoryIds) {
            queryParams.append('category_ids[]', selectedCategoryIds);
          }
  
          if (Array.isArray(selectedOriginIds)) {
            selectedOriginIds.forEach((id) => queryParams.append('origin_ids[]', id));
          } else if (selectedOriginIds) {
            queryParams.append('origin_ids[]', selectedOriginIds);
          }
          if (Array.isArray(selectedBrandName)) {
            selectedBrandName.forEach((id) => queryParams.append('brands[]', id));
          } else if (selectedBrandName) {
            queryParams.append('brands[]', selectedBrandName);
          }
          if (Array.isArray(selectedPicImport)) {
            selectedPicImport.forEach((id) => queryParams.append('pic_staff_member_import[]', id));
          } else if (selectedPicImport) {
            queryParams.append('pic_staff_member_import[]', selectedPicImport);
          }
          if (Array.isArray(selectedPicSales)) {
            selectedPicSales.forEach((id) => queryParams.append('pic_staff_member_sales[]', id));
          } else if (selectedPicSales) {
            queryParams.append('pic_staff_member_sales[]', selectedPicSales);
          }
  
          queryParams.append('search', trimmedSearch);
          queryParams.append('page', perPageSearch);
          queryParams.append('per_page', 20);

          const resp = await getApi(`/product?${queryParams.toString()}`);
          // if (!isCancelled) {
            if (resp?.success === true) {
              setTotalProduct(resp?.data?.products?.total)
              const newData = resp?.data?.products?.data || [];

              const newProducts = [...productData, ...newData];
              // setProductData(prev => [...prev, ...(resp?.data?.products?.data || [])]);
              if(perPageSearch!==1){
                setProductData(newProducts)
              }else{
                setProductData(newData)
              }
              
              if (selectAll) {
                if (newData?.length > 0) {
                  const toMerge = perPageSearch !== 1 ? newProducts : newData;

                  const mergedById = Array.from(
                    new Map([...selectedProductsData, ...toMerge].map(item => [item.id, item])).values()
                  );

                  handleSelectAll(mergedById);
                }
              }
            } else {
              setProductData([]);
            }
          // }
          setProductLoader(false)
        } catch (error) {
          if (!isCancelled) {
            console.error('Fetch failed', error);
            // setProductData([]);
          }
          setProductLoader(false)
        }
      } else {
        setProductLoader(false)
        setProductData([]);
        // setProductIds([]);
        // setSelectedProductsData([]);
      }
    };
  
    runFetch();
  
    return () => {
      isCancelled = true;
    };
  }, [
    perPageSearch,
    searchValue, // no need to add .trim() here — done inside the effect
    selectedCategoryIds?.length,
    selectedOriginIds?.length,
    selectedBrandName,
    selectedPicImport,
    selectedPicSales
  ]);
  
  

  useEffect(()=>{
    if(searchValue=='' && selectedCategoryIds?.length==0 && selectedOriginIds?.length==0 ){
      setProductData([]);
      setSelectAll(false)
      // setProductIds([]);
      // setSelectedProductsData([])
    }
  },[searchValue])


  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {

    // Priority 1: Trigger when selectAll is false and productIds change
    if (!selectAll) {
      fetchData();
      return;
    }
  
    // Priority 2: Trigger when filters/searching updates
    if (
      productIds?.length > 0 ||
      searchValue !== '' ||
      selectedCategoryIds?.length > 0 ||
      selectedOriginIds?.length > 0 ||
      selectedBrandName ||
      selectedPicImport ||
      selectedPicSales
    ) {
      fetchData();
    }
  }, 1000);
  return () => {
    clearTimeout(delayDebounceFn);
  };
  }, [
    productIds,
    dateState,
    // selectedCategoryIds,
    // selectedOriginIds,
    // selectedBrandName,
    currentPage,
    // selectedPicImport,
    // selectedPicSales,
    selectAll,
    // searchValue,
  ]);
  
  const fetchData = async () => {
    if (productIds?.length > 0) {
      // if (
      //   searchValue !== '' &&
      //   selectedCategoryIds?.length === 0 &&
      //   selectedOriginIds?.length === 0 &&
      //   productIds?.length === productData?.length &&
      //   selectAll
      // ) {
        await getInOutData();
      // } else {
      //   await getInOutData();
      // }
    } else {
      setInoutData([]);
      setProductSearchInput('');
      setSelectAll(false);
    }
  };
  

  useEffect(() => {
    if (!isSearching) return;
    function handleClickOutside(event) {
      if (
        productSearchRef.current &&
        !productSearchRef.current.contains(event.target)
      ) {
        // Only close if input is empty
        if (!productSearchInput) {
          setIsSearching(false);
        }
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSearching, productSearchInput]);

  const fetchProductData = async () => {
    // let url = `/product?per_page=${perPageSearch}`;
    // if (productSearchInput && productSearchInput.trim() !== '') {
    //   url += `&search=${encodeURIComponent(productSearchInput.trim())}`;
    // }
    // const resp = await getApi(url);
    const queryParams = new URLSearchParams();
    if (Array.isArray(selectedCategoryIds)) {
      selectedCategoryIds.forEach((id) => queryParams.append('category_ids[]', id));
    } else if (selectedCategoryIds) {
      queryParams.append('category_ids[]', selectedCategoryIds);
    }
    // if (Array.isArray(selectedBrandName)) {
    //   selectedBrandName.forEach((id) => queryParams.append('brands[]', id));
    // } else if (selectedBrandName) {
    //   queryParams.append('brands[]', selectedBrandName);
    // }
    if (Array.isArray(selectedOriginIds)) {
      selectedOriginIds.forEach((id) => queryParams.append('origin_ids[]', id));
    } else if (selectedOriginIds) {
      queryParams.append('origin_ids[]', selectedOriginIds);
    }
    queryParams.append('search', searchValue);
    queryParams.append('page', 1);
    queryParams.append('per_page', perPageSearch);
    const resp = await getApi(`/product?${queryParams.toString()}`);
    if (resp?.success === true) {
      setProductData(resp?.data?.products?.data || []);
    } else {
      setProductData([]);
    }
  };
  const handleDateFilterChange = (dates) => {
    if (dates) {
      setDateState({
        startDate: dates[0] ? dayjs(dates[0]).format('YYYY-MM-DD') : null,
        endDate: dates[1] ? dayjs(dates[1]).format('YYYY-MM-DD') : null
      });
    } else {
      setDateState({
        startDate: null,
        endDate: null
      });
    }

  }

  const debounceTimer = useRef(null);

  // Add debounced search function
  const debouncedSearch = useCallback((value) => {
    // Immediately update the input value for responsive typing
    setSearchInputValue(value);
    
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }
    
    debounceTimer.current = setTimeout(() => {
      setSearchValue(value);
      setPerPageSearch(1);
    }, 1000);
  }, []);

  const handlePageClick = (selected) => {
    setCurrentPage(selected);
  };

  const handleSaveArrivalData = async () => {
    setArrivalModalLoading(true)
    if (!Array.isArray(arrivalModalData?.products) || arrivalModalData.products.length === 0) {
      setArrivalModalError('No products available.');
      setArrivalModalLoading(false)
      return;
    }
    if (arrivalModalData?.eta == '' || arrivalModalData?.eta == null) {
      setArrivalModalError('ETA field not be empty');
      setArrivalModalLoading(false)
      return;
    }
    const selectedProduct = arrivalModalData.products.find(x => x.id === selectedArrivalProductId) ||
      arrivalModalData.products[0];
    if (!selectedProduct) {
      setArrivalModalError('Selected product not found.');
      setArrivalModalLoading(false)
      return;
    }
    // Here you would typically call your API or update state
    const quantity = arrivalQuantityMap[selectedProduct.id] ?? selectedProduct.quantity;
    const val = {
      quantity: arrivalQuantityMap[selectedArrivalProductData?.id],
      barcode: selectedArrivalProductData?.barcode,
      eta: arrivalModalData?.eta,
    }
    const resp = await putApi(`/arrival-summary/product-update/${selectedArrivalProductData?.arrival_summary_product_id}`, val)
    if (resp?.success === true) {
      fetchData()
      setArrivalModalShow(false);
      setArrivalModalData({});
      setSelectedArrivalProductId(null);
      setArrivalQuantityMap({});
    }
    setArrivalModalLoading(false)
    setArrivalModalError('');
  }



  useEffect(() => {
    if (
      modalReserve &&
      Array.isArray(reserveModalUpdateData) &&
      reserveModalUpdateData.length > 0
    ) {
      setSelectedProductId(reserveModalUpdateData[0].product_id);
      setQuantityValue(reserveModalUpdateData[0].quantity || 0);
    }
  }, [modalReserve, reserveModalUpdateData]);

  useEffect(() => {
    // if (
    //   labelData &&
    //   labelData[0]?.groupLabel?.length > 0 &&
    //   !selectedProductId // only set if not already set
    // ) {
    //   const first = labelData[0].groupLabel[0];
    //   setSelectedProductId(first.id);
    //   const matchedSubGroup = labelData[0]?.subGroups?.find(
    //     (subgroup) => first.id === subgroup.customer_group_id
    //   );

    //   setQuantityValue(matchedSubGroup?.quantity || 0);
    //   setGroupName(first.id);
    // }
    if (!labelData || labelData.length === 0 || selectedProductId) return;

    const firstItem = labelData[0];
  
    if (firstItem.subGroups?.length > 0) {
      const firstSub = firstItem.subGroups[0];
      setSelectedProductId(firstSub.id);
      setQuantityValue(firstSub.quantity || 0);
      setGroupName(firstSub.customer_group_id);
    } else if (firstItem.groupLabel?.length > 0) {
      const firstGroup = firstItem.groupLabel[0];
      setSelectedProductId(firstGroup.id);
      setQuantityValue(0);
      setGroupName(firstGroup.id);
    }
  }, [labelData]);

  useEffect(() => {
    if (
      Array.isArray(reserveModalUpdateData) &&
      reserveModalUpdateData.length > 0 &&
      selectedProductId !== null
    ) {
      const selected = reserveModalUpdateData.find(x => x.product_id === selectedProductId);
      if (selected) {
        setQuantityValue(selected.quantity || 0);
      }
    }
  }, [reserveModalUpdateData, selectedProductId]);

  const handleProductId = (data) => {
    setSelectAll(false)
    const id = data?.id;
    setProductIds(prev => {
      const newIds = prev.includes(id)
        ? prev.filter(pid => pid !== id)
        : [...prev, id];
      return newIds;
    });

    setSelectedProductsData(prev => {
      const exists = prev.some(p => p.id === id);
      if (exists) {
        return prev.filter(p => p.id !== id);
      } else {
        return [...prev, data];
      }
    });
  }
  const queryParams = {
    'from_date': dateState.startDate,
    'to_date': dateState.startDate,
  }

  // Initialize arrival modal selection when modal opens
  useEffect(() => {
    if (
      arrivalModalShow &&
      Array.isArray(arrivalModalData?.products) &&
      arrivalModalData.products.length > 0
    ) {
      const firstId = arrivalModalData.products[0].id;
      setSelectedArrivalProductId(firstId);
      setSelectedArrivalProductData(arrivalModalData.products[0])
      setArrivalQuantityMap({
        [firstId]: arrivalModalData.products[0].quantity || ''
      });
    }
  }, [arrivalModalShow, arrivalModalData]);

  const handleSelectAll = (data) =>{
    setSelectAll(true)
    if (!Array.isArray(data)) return;
    const ids = data.map(item => item.id);
    const dataMap = [];
    
    data.forEach(item => {
      // dataMap[item.id] = item;
      dataMap.push(item);
    });
    
    const areArraysEqual = (a, b) =>
      Array.isArray(a) &&
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(item => b.includes(item)) &&
      b.every(item => a.includes(item));

    if (!areArraysEqual(productIds, ids)) {
      setProductIds(ids);
      setSelectedProductsData(dataMap);
    }
  }

  let scrollTimeout;
  const handleScrollToBottom = (e) => {
    if (scrollTimeout) clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      const { scrollLeft, scrollWidth, clientWidth } = e.target;
      // if (scrollLeft + clientWidth >= scrollWidth - 10) {
      //   if(totalProduct >productData?.length){
      //   setPerPageSearch(prev => prev + 1);
      //   }
      // }
      const scrolledPercentage = (scrollLeft + clientWidth) / scrollWidth;

      // If user scrolled to 80% or more
      if (scrolledPercentage >= 0.8) {
        if (totalProduct > productData?.length) {
          setPerPageSearch(prev => prev + 1);
        }
      }
    }, 300);
  };

    const isDeepEmpty = (obj) => {
  if (Array.isArray(obj)) return obj.length === 0;

  if (typeof obj === 'object' && obj !== null) {
    return Object.values(obj).every(value => isDeepEmpty(value));
  }

  return false; // primitive value or non-empty
};

  return (
    <>
      <div class="RightSideDiv inout-right">
        {showImportModal && (
          <Import
            setImportFile={setImportFile}
            importFile={importFile}
            searchQuery={''}
            fetchData={fetchData}
            setShowImportModal={setShowImportModal}
            routeEnd={'/reserve/import'}
            routeexport={`/inventory/export`}
            type={'Direct Inout'}
            queryParams={queryParams}
          />
        )}
        <div className="row">
          <div className="col-sm-12">
            <div className="setting-right setting-right-table table-border-show arrival">
              <div class="in-out">
                <div class="table-header  border-bt">
                  <div class="header-left">
                    <div class="search-card only-arival">
                      <img src={window.getPublicUrl('/assets/images/search-icon.svg')} alt="" />
                      <input type="text" class="search-input" placeholder="Search Product Name/Code" value={searchInputValue} onChange={(e) => debouncedSearch(e?.target?.value)} />
                    </div>


                  </div>
                  <div class="table-actions">
                    <button class="btn add" onClick={() => { navigate('/admin/reserve'); localStorage.setItem("reserveMethod", true) }}>+ Add Reserve </button>
                    <button class="btn add sales-delivery-report"
                      onClick={() => handleImportClickFile(setShowImportModal, setImportFile, setImportErrors)}>
                      + Sales Delivery Report</button>
                    <button class="btn" onClick={() => exportData(tableRef)}><img src={window.getPublicUrl('/assets/images/export.svg')} alt="" />Export</button>
                  </div>
                </div>
                <div class="table-header table-second ">
                  <div class="links">
                    <div>
                      <MultiSelectDropdown
                        categoryData={categoryData}
                        selectedCategories={selectedCategoryIds}
                        setSelectedCategories={(selected) => {
                          setSelectedCategoryIds(selected);
                          setPerPageSearch(1);
                        }}
                        placeholder='Select Categories...'
                        noOptionsMessage='No categories available'
                        setCurrentPage={setCurrentPage}
                        fetchOptionsApi={fetchCategoryDataFilter}
                      />
                    </div>

                    <div>
                      <MultiSelectDropdown
                        categoryData={originData}
                        selectedCategories={selectedOriginIds}
                        setSelectedCategories={(selected) => {
                          setSelectedOriginIds(selected);
                          setPerPageSearch(1);
                        }}
                        placeholder="Select origin..."
                        noOptionsMessage='No origin available'
                        setCurrentPage={setCurrentPage}
                        fetchOptionsApi={fetchOriginDataFilter}
                      />
                    </div>

                    <div >
                      <MultiSelectDropdown
                        categoryData={brandData}
                        selectedCategories={selectedBrandName}
                        setSelectedCategories={setSelectedBrandName}
                        placeholder="Select brand..."
                        noOptionsMessage='No Brand available'
                        setCurrentPage={setCurrentPage}
                        fetchOptionsApi={fetchBrandFilter}
                      />
                    </div>
                    <div className='selctions-option'>
                      <RangePicker
                        key={'pathName'}
                        onChange={handleDateFilterChange}
                        separator={'-'}
                        value={[
                          dateState.startDate ? dayjs(dateState.startDate) : null,
                          dateState.endDate ? dayjs(dateState.endDate) : null
                        ]}
                        allowClear={false}
                      />
                    </div>
                    <div >
                      <MultiSelectDropdown
                        categoryData={picImportData}
                        selectedCategories={selectedPicImport}
                        setSelectedCategories={setSelectedPicImport}
                        placeholder="Select pic import ..."
                        noOptionsMessage='No pic import available'
                        setCurrentPage={setCurrentPage}
                        fetchOptionsApi={fetchPicImportDataFilter}
                      />
                    </div>

                    <div >
                      <MultiSelectDropdown
                        categoryData={picSalesData}
                        selectedCategories={selectedPicSales}
                        setSelectedCategories={setSelectedPicSales}
                        placeholder="Select pic sales..."
                        noOptionsMessage='No pic sales available'
                        setCurrentPage={setCurrentPage}
                        fetchOptionsApi={fetchPicSalesDataFilter}
                      />
                    </div>
                  </div>
                </div>

                <div className="main-inout-table-srcoll">
                  <div class="table-container-inner">
                      {(productData?.length>0 || selectedProductsData?.length>0) &&
                      <>
                    <div className="table-left">
                      <div className="header-main header-left">
                        <div className="header with-input">
                          {/* {!isSearching ? (
                            <label onClick={() =>{if(selectedCategoryIds?.length>0 || selectedOriginIds?.length>0){ setIsSearching(true)}}} style={{ cursor: "pointer" }} className='mb-0'>
                              All Products{" "}
                              <img
                                src={window.getPublicUrl("/assets/images/white-seqarch.svg")}
                                alt=""
                              />
                            </label>
                          ) : (
                            // Wrap input and clear button in a div with the ref
                            <div ref={productSearchRef} style={{ display: "flex", alignItems: "center" }}>
                              <input
                                type="text"
                                className="search-input"
                                placeholder="Search Product Name/Code"
                                value={productSearchInput}
                                onChange={(e) => setProductSearchInput(e.target.value)}
                                style={{ marginBottom: 8 }}
                                autoFocus
                              />
                              <img
                                src={window.getPublicUrl("/assets/images/cross-black.svg")}
                                alt="Clear"
                                style={{ cursor: "pointer", marginLeft: 8 }}
                                onClick={() => {
                                  setProductSearchInput("");
                                  setIsSearching(false);
                                }}
                              />
                            </div>
                          )} */}
                         {(productData.length>0 || selectedProductsData.length>0) && <button type='button' onClick={() => {
                          //  const visibleProducts = productData || [];
                          //  const visibleProduct = selectedProductsData || [];
                           
                           const filteredUnselectedVisibleProducts = productData.filter(
                             product => !selectedProductsData.some(vp => vp.id === product.id)
                           );
                           
                           handleSelectAll([...selectedProductsData, ...filteredUnselectedVisibleProducts]);
                         }} className='btn add'>Select All</button>}
                        </div>
                        {selectedProductsData.length > 0 &&
                        <div className="header-second text-center justify-content-center">

                        <p className="selected-product mb-0">Selected Product</p>
                          {/* {selectedProductsData.length > 0 && */}
                            <>
                              <button type='button' onClick={() => {
                                setSelectedProductsData([]);
                                setProductIds([]);
                                // setSearchValue('');
                                setSelectAll(false)
                              }} className='btn add' disabled={selectedProductsData.length === 0}>Clear All</button>
                            </>
                          {/* } */}
                        </div>
                        }
                      </div>
                    </div>
                    <div class="table-right">
                      <div className="header-main">
                        <div className="header"  onScroll={handleScrollToBottom}>
                        {/* <div
    className="product-scroll-container"
    onScroll={handleScrollToBottom}
    style={{ maxHeight: 200, overflowY: "auto" }}
  > */}
                          {(() => {
                            // const visibleProducts = productData || [];
                            // const visibleProduct = selectedProductsData || [];

                            // Filter out products from visibleProducts that already exist in visibleProduct
                            const filteredUnselectedVisibleProducts = productData.filter(
                              product => !selectedProductsData.some(vp => vp.id === product.id)
                            );

                            const hasProducts = filteredUnselectedVisibleProducts.length > 0;
                            const hasSelectedProducts = selectedProductsData.length > 0;
                            const hasMoreProducts = productData.length >= perPageSearch;
                            return (
                              <>
                                {hasSelectedProducts  && (
                                // {hasSelectedProducts && visibleProducts?.length > 0 && (
                                  <div className="d-flex gap-3">
                                    {selectedProductsData.map((x) => (
                                      <h6
                                        key={x.id}
                                        onClick={() => handleProductId(x)}
                                        className={
                                          productIds.some(selId => String(x.id) === String(selId))
                                            ? "product-add active"
                                            : ""
                                        }
                                      >
                                        {x?.name_tc}
                                      </h6>
                                    ))}
                                  </div>
                                )}

                                {hasProducts && (
                                  <div className="d-flex gap-3">
                                    {filteredUnselectedVisibleProducts.map((x) => (
                                      <h6
                                        key={x.id}
                                        onClick={() => handleProductId(x)}
                                        className={
                                          productIds.some(selId => String(x.id) === String(selId))
                                            ? "product-add active"
                                            : ""
                                        }
                                      >
                                        {x?.name_tc}
                                      </h6>
                                    ))}
                                    {/* {productIds.length > 10 && (
                                      <div className="">
                                        <button
                                          key="more-btn"
                                          onClick={() => setPerPageSearch(perPageSearch + 10)}
                                          className="bg-transparent border-0"
                                        >
                                          <img
                                            src={window.getPublicUrl("/assets/images/right-more.svg")}
                                            alt="Search"
                                          />
                                        </button>
                                      </div>
                                    )} */}
                                  </div>
                                )}

                                {productData?.length == 0 && !hasProducts && !hasSelectedProducts &&(
                                  <div style={{ color: "#888", fontSize: 14, marginTop: 8 }}>
                                    No products found.
                                  </div>
                                )}
                                {/* {hasMoreProducts && hasProducts && (
                                  <div className="">
                                    <button
                                      key="more-btn"
                                      onClick={() => setPerPageSearch(perPageSearch + 10)}
                                      className="bg-transparent border-0"
                                    >
                                      <img
                                        src={window.getPublicUrl("/assets/images/right-more.svg")}
                                        alt="Search"
                                      />
                                    </button>
                                  </div>
                                )} */}
                              </>
                            );
                          })()}
                          </div>

                        {/* </div> */}
                        <div class="header-second">
                          {selectedProductsData.length > 0 &&
                            selectedProductsData.map((x) => {
                              return (
                                <div key={x.id} className="">
                                  <h6>Product Code {x?.code} </h6>
                                  <h6>Product Name : {x?.name_tc} </h6>
                                  <h6>Specification : {x?.specification}</h6>
                                </div>
                              );
                            })}
                        </div>
                        {productLoader &&   <div className='loader-div'>             
                     
                      <span class="loader spniner-table"></span>
                         
                          </div>}
                      </div>
                          {/* {!productLoader && 
                      <span class="loader spniner-table"></span>
                          } */}
                    </div>
</>
}
                  </div>

                  {/* <div className={`scroll-wrapper-inout  ${(Object.keys(inoutData).length > 0 ) ? '' : productIds?.length>0? 'no-data-found': (productIds?.length<=0 )?'no-data-show': isDeepEmpty(inoutData)? 'no-data' :''}`} onScroll={handleScroll} > */}
                  <div
  className={`scroll-wrapper-inout ${
    Object.keys(inoutData).length > 0
      ? ''
      : productIds?.length > 0
      ? 'no-data-found'
      : (productIds?.length <= 0 && productData?.length===0) 
      ? 'no-data-show'
      : isDeepEmpty(inoutData)
      ? 'no-data'
      : ''
  }`}
  onScroll={handleScroll}
>

                    <div
                      class={`scroll-container inout-main-table ${(isDeepEmpty(inoutData) && productIds?.length>0 )? 'no-table-data' : ''} ${loader ? "spinner-table" : ""
                        } ${scrolled ? "scrolled" : ""} ${loader?'on-loding-show-data':''}`}
                  >
                      {productIds?.length > 0 ?
                        <>
                          {tableLoader ? ( 
                            <div className="spinner-border spinner-border-sm" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          ) : (
                            <>
                            
                            {/* // GenerateTable() */}
                            <MemoizedGenerateTable arrivalsData={''} dateState={dateState}
                              currentPage={currentPage}
                              inoutData={inoutData}
                              setModalReserve={setModalReserve}
                              setReserveModalUpdateData={setReserveModalUpdateData}
                              showGroupData={showGroupData}
                              setshowGroupData={setshowGroupData}
                              setSelectedGroupProducts={setSelectedGroupProducts}
                              setArrivalModalData={setArrivalModalData}
                              tableRef={tableRef}
                              setShowAllArrivals={setShowAllArrivals}
                              showAllArrivals={showAllArrivals}
                              selectedGroupProducts={selectedGroupProducts}
                              setArrivalModalShow={setArrivalModalShow}
                              isEditing={isEditing}
                              updateId={updateId}
                              updateDate={updateDate}
                              updateProduct={updateProduct}
                              updateValue={updateValue}
                              setIsEditing={setIsEditing}
                              setUpdateValue={setUpdateValue}
                              setUpdateId={setUpdateId}
                              setUpdateDate={setUpdateDate}
                              setUpdateProduct={setUpdateProduct}
                              updateReserveData={debouncedUpdateReserveData}
                              arrivalModalShow={arrivalModalShow}
                              setSelectedArrivalProductId={setSelectedArrivalProductId}
                              setArrivalQuantityMap={setArrivalQuantityMap}
                              arrivalModalData={arrivalModalData}
                              selectedArrivalProductId={selectedArrivalProductId}
                              setSelectedArrivalProductData={setSelectedArrivalProductData}
                              setArrivalModalError={setArrivalModalError}
                              arrivalQuantityMap={arrivalQuantityMap}
                              arrivalModalError={arrivalModalError}
                              arrivalModalLoading={arrivalModalLoading}
                              handleSaveArrivalData={handleSaveArrivalData}
                              modalReserve={modalReserve}
                              modalRef={modalRef}
                              setReserveModalError={setReserveModalError}
                              reserveModalUpdateData={reserveModalUpdateData}
                              selectedProductId={selectedProductId}
                              setSelectedProductId={setSelectedProductId}
                              setQuantityValue={setQuantityValue}
                              quantityValue={quantityValue}
                              reserveModalError={reserveModalError}
                              toastMessage={toastMessage}
                              setProductLabelModal={setProductLabelModal}
                              productLabelModal={productLabelModal}
                              setLabelData={setLabelData}
                              labelData={labelData}
                              setSubGroup={setSubGroup}
                              subGroup={subGroup}
                              setGroupName={setGroupName}
                              groupName={groupName}
                              setProductName={setProductName}
                              productName={productName}
                              setLabelDate={setLabelDate}
                              labelDate={labelDate}
                              loader={loader}
                              setProductGroupLabelModal={setProductGroupLabelModal}
                              productGroupLabelModal={productGroupLabelModal}
                              setModalType={setModalType}
                              modalType={modalType}
                              groupRef={groupRef}
                              firstRadioRefProductLabel={firstRadioRefProductLabel}
                              firstRadioArrivalRef={firstRadioArrivalRef}
                              quatityRef={quatityRef}
                            />
                            {/* {isDeepEmpty(inoutData) && <p className='no-dtata-records'>No data found for select filter </p>} */}

                            </>
                          )}
                        </>
                        :
                        <div className='no-dtata-records'>{(searchValue!=='' || selectedCategoryIds?.length>0 || selectedOriginIds?.length>0 || selectedBrandName?.length>0 || selectedPicImport?.length>0 || selectedPicSales?.length>0) ? productData?.length===0 ? 'No product found for this filter':'Please select products to view the data' :'Please select filter to view the product' }</div>
                      }
                    </div>
                  </div>
                </div>

              </div>
              {/* {toastMessage && <p>Please wait....</p>} */}
              {loader && (
                <div style={{
                  position: 'fixed',
                inset: '341px',
                zIndex: 9999,
                margin: '0 auto',
                textAlign: 'center',
                width: '85%',
                justifyContent: 'center',
                }}>
                  <div className="spinner-border spinner-border-lg" role="status">
                    <span className="visually-hidden">Loading...</span>
                   
                  </div>
                   <p className='d-block uploading-data-text'>Updating please wait....</p>
                </div>
              )}
               <div class="table-footer d-flex justify-content-between table-pagination">
                <div className=''>
                  <p className='show-records'>
                    {(productIds?.length>0) &&
                    `Showing {
                      ${Math.min((currentPage - 1) * itemsPerPage + 1, allDatess?.length || 0)} to ${Math.min(currentPage * itemsPerPage, allDatess?.length || 0)}
                    } of ${allDatess?.length || 0} entries`
                  }
                  </p>
                </div>
                <div className=''>
                {(productIds?.length>0) &&
                  <TableFooter
                    pageCount={totalPage}
                    handlePageClick={handlePageClick}
                    currentPage={currentPage}
                  />
                }
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  )
}

export default React.memo(Inout)